import React, { useEffect } from 'react'

import { useWindowSize } from '@react-hook/window-size'
import PropTypes from 'prop-types'

import Icon from '../../helpers/Icon'
import Link from '../../helpers/Link'
import * as S from './styled'

const DropdownItem = ({ i, open, setOpen, label, to, dropdown }) => {
  const [width] = useWindowSize()
  let isOpen = i === open

  useEffect(
    (width) => {
      if (width >= 769) {
        setOpen(false)
        isOpen = false
      }
    },
    [width]
  )

  return (
    <S.HeaderNavItem isDropdown>
      <S.HeaderNavLink
        href="#"
        onClick={(e) => {
          e.preventDefault()
          setOpen(isOpen ? false : i)
        }}
        title={label}
      >
        {label}
        <S.HeaderChevron
          className="accordion__icon"
          name={`arrow-down-1`}
          size={12}
          color="neutral950"
        />
      </S.HeaderNavLink>
      <S.HeaderDropdown
        className="with-shadow-sm-2dp"
        initial="collapsed"
        animate={isOpen ? 'open' : 'collapsed'}
        exit="collapsed"
        variants={{
          open: { opacity: 1, height: 'auto' },
          collapsed: { opacity: 0, height: 0 }
        }}
        transition={{ duration: 0.4 }}
      >
        {dropdown.map(({ icon, label, headline, to, color, ...props }, key) => (
          <S.HeaderDropdownLink
            key={key}
            as={Link}
            to={to}
            title={label}
            {...props}
          >
            {icon && <Icon name={icon} size={32} />}
            <S.HeaderDropdownContent>
              <S.HeaderDropdownLabel color={color}>
                {label}
              </S.HeaderDropdownLabel>
              <S.HeaderDropdownHeadline>{headline}</S.HeaderDropdownHeadline>
            </S.HeaderDropdownContent>
          </S.HeaderDropdownLink>
        ))}
      </S.HeaderDropdown>
    </S.HeaderNavItem>
  )
}

DropdownItem.propTypes = {
  i: PropTypes.number,
  label: PropTypes.string,
  to: PropTypes.string,
  dropdown: PropTypes.array,
  open: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]).isRequired,
  setOpen: PropTypes.func.isRequired
}

export default DropdownItem
